import { createFeatureSelector, createSelector } from '@ngrx/store';
import { DocumentItem } from '@klubovna/shared-models';
import { DocumentsState } from './documents.state';

export const selectDocumentsState = createFeatureSelector<DocumentsState>('documents');

export const selectAllDocuments = createSelector(selectDocumentsState, (state) => state.documents);
export const selectDocumentsLoading = createSelector(selectDocumentsState, (state) => state.loading);
export const selectDocumentsError = createSelector(selectDocumentsState, (state) => state.error);

export const getDocumentByIdentifier = (identifier: string) =>
  createSelector(
    selectAllDocuments,
    (documents: DocumentItem[]) => documents.find((doc) => doc.identifier === identifier) ?? null,
  );
